/**
 * Words that appear on many screens. Kept in one place so "Save" is not
 * translated three different ways on three pages.
 */
const en = {
  save: 'Save',
  saving: 'Saving…',
  saved: 'Saved',
  cancel: 'Cancel',
  close: 'Close',
  delete: 'Delete',
  remove: 'Remove',
  edit: 'Edit',
  create: 'Create',
  add: 'Add',
  search: 'Search',
  filter: 'Filter',
  refresh: 'Refresh',
  retry: 'Retry',
  copy: 'Copy',
  copied: 'Copied',
  download: 'Download',
  loading: 'Loading…',
  none: 'None',
  all: 'All',
  yes: 'Yes',
  no: 'No',
  enabled: 'Enabled',
  disabled: 'Disabled',
  on: 'On',
  off: 'Off',
  back: 'Back',
  next: 'Next',
  done: 'Done',
  apply: 'Apply',
  reset: 'Reset',
  test: 'Test',
  connect: 'Connect',
  disconnect: 'Disconnect',
  open: 'Open',
  view: 'View',
  details: 'Details',
  status: 'Status',
  name: 'Name',
  email: 'Email',
  role: 'Role',
  project: 'Project',
  allProjects: 'All projects',
  date: 'Date',
  actions: 'Actions',
  never: 'Never',
  unknown: 'Unknown',
  noData: 'No data yet.',
  nothingFound: 'Nothing found.',
  somethingWrong: 'Something went wrong.',
  requiresAdmin: 'This screen is for administrators.',
  comingSoon: 'Coming soon',
  /** Plan gates, used wherever a feature is above the current plan. */
  upgradeRequired: 'Available on a higher plan.',
  learnMore: 'Learn more',
};

const tr: typeof en = {
  save: 'Kaydet',
  saving: 'Kaydediliyor…',
  saved: 'Kaydedildi',
  cancel: 'Vazgeç',
  close: 'Kapat',
  delete: 'Sil',
  remove: 'Kaldır',
  edit: 'Düzenle',
  create: 'Oluştur',
  add: 'Ekle',
  search: 'Ara',
  filter: 'Filtrele',
  refresh: 'Yenile',
  retry: 'Tekrar dene',
  copy: 'Kopyala',
  copied: 'Kopyalandı',
  download: 'İndir',
  loading: 'Yükleniyor…',
  none: 'Yok',
  all: 'Tümü',
  yes: 'Evet',
  no: 'Hayır',
  enabled: 'Açık',
  disabled: 'Kapalı',
  on: 'Açık',
  off: 'Kapalı',
  back: 'Geri',
  next: 'İleri',
  done: 'Tamam',
  apply: 'Uygula',
  reset: 'Sıfırla',
  test: 'Test et',
  connect: 'Bağlan',
  disconnect: 'Bağlantıyı kes',
  open: 'Aç',
  view: 'Görüntüle',
  details: 'Ayrıntılar',
  status: 'Durum',
  name: 'Ad',
  email: 'E-posta',
  role: 'Rol',
  project: 'Proje',
  allProjects: 'Tüm projeler',
  date: 'Tarih',
  actions: 'İşlemler',
  never: 'Hiç',
  unknown: 'Bilinmiyor',
  noData: 'Henüz veri yok.',
  nothingFound: 'Sonuç bulunamadı.',
  somethingWrong: 'Bir şeyler ters gitti.',
  requiresAdmin: 'Bu ekran yöneticiler içindir.',
  comingSoon: 'Yakında',
  upgradeRequired: 'Üst planlarda kullanılabilir.',
  learnMore: 'Daha fazla bilgi',
};

export const common = { en, tr };
